var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4368 10.06L9.0687 4.96251C8.99829 4.88039 8.91095 4.81447 8.81267 4.76928C8.71439 4.72408 8.60749 4.70068 8.49932 4.70068C8.39115 4.70068 8.28425 4.72408 8.18598 4.76928C8.0877 4.81447 8.00035 4.88039 7.92995 4.96251L3.56182 10.06C3.14495 10.5466 3.49057 11.2981 4.1312 11.2981H12.8687C13.5093 11.2981 13.8549 10.5466 13.4368 10.06Z",
    fill: "#2D5D2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.4515e6e6b35fb5785c1d139b9263c9e5.svg";
export { ForwardRef as ReactComponent };